import { Breadcrumbs } from '@moonpig/web-core-nav'
import React, { FC } from 'react'
import { useStoreId } from '@moonpig/web-core-stores'
import { styled, breakpointDown } from '@moonpig/launchpad-utils'
import { useProductContext } from '../../../contexts/product'
import { useFindLocaleText } from '../../../text-localisation'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'
import { usePreviousItems } from './usePreviousItems'

const BREAKPOINT = 'lg'

const StyledBreadCrumbs = styled(Breadcrumbs)`
  ${breakpointDown(BREAKPOINT)} {
    display: none;
  }
`

export const BreadcrumbsModule: FC<ProductModule> = props => {
  const [
    {
      product: {
        id,
        title,
        slug,
        category: { slug: departmentSlug },
      },
    },
  ] = useProductContext()
  const storeId = useStoreId()
  const localiseText = useFindLocaleText()

  const previousItems = usePreviousItems({ storeId, departmentSlug })

  const departmentTitle = departmentSlug
    .split('-')
    .map(word => word.replace(/\b\w/g, l => l.toUpperCase()))
    .join(' ')

  const breadcrumbsItems = [
    {
      url: `/${storeId}/`,
      label: localiseText('find.home'),
    },
    {
      url: `/${storeId}/${departmentSlug}/`,
      label: departmentTitle,
    },
    ...previousItems,
    {
      url: `/${storeId}/${departmentSlug}/p/${slug}/${id}/`,
      label: title,
    },
  ]

  return (
    <ProductModuleSection {...props} pt={4}>
      <StyledBreadCrumbs items={breadcrumbsItems} />
    </ProductModuleSection>
  )
}
